import Slider from '../components/Slider';
import BackgroundImage from '../core/BackgroundImage';

const defaults = {
  wrapAround: true,
  pageDots: true,
  prevNextButtons: true,
  autoPlay: true,
  adaptiveHeight: false,
  draggable: false,
  pauseAutoPlayOnHover: true,
  imagesLoaded: true,
  setGallerySize: false,
};

export default class Infographic {
  constructor(element) {
    this.element = element;
    this.settings = defaults;
    this.Slider = new Slider(this.container, this.settings);
    this.init();
    this.ready();
  }

  init() {
    this.element.querySelectorAll('.node-hero-infographic').forEach((elem) => {
      if (elem && !elem.bg) {
        elem.bg = new BackgroundImage(elem, {
          destSelector: 'img',
        });
      }
      const elemLink = elem.querySelector('a');
      if (elemLink) {
        elemLink.setAttribute('target', '_self');
      }
    });
  }

  ready() {
    setTimeout(() => {
      this.element.classList.add('ready');
    }, 200);
  }

  get container() {
    return this.element.querySelector('.node-flickity-slider');
  }
}
